import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import {
  FAQContainer,
  SectionTitle,
  FAQAccordion,
  FAQAccordionCollapsed,
  FAQSummary,
  FAQQuestion,
  FAQDetails,
  FAQAnswer
} from '../styles';

interface FAQ {
  id: string;
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    id: 'faq1',
    question: 'What is Agentic Commerce?',
    answer: 'Agentic Commerce is the next evolution of digital commerce where AI-powered agents, like ChatGPT and Perplexity, research, recommend, and purchase products on behalf of consumers or businesses.',
  },
  {
    id: 'faq2',
    question: 'How does Logicbroker support Agentic Commerce?',
    answer: 'Logicbroker connects your digital infrastructure to AI platforms via secure MCP integrations, ensuring your products remain visible and transactable inside AI ecosystems.',
  },
  {
    id: 'faq3',
    question: 'Do I need to change my existing systems to support Agentic Commerce?',
    answer: 'No. Logicbroker layers on top of your current eCommerce stack, bridging AI and traditional channels through our Intelligent Commerce Network.',
  },
  {
    id: 'faq4',
    question: 'What are the benefits of being AI-ready?',
    answer: 'Brands gain visibility in emerging discovery platforms, maintain control over data accuracy, and capture incremental sales driven by AI recommendations.',
  },
  {
    id: 'faq5',
    question: 'How can I measure success in Agentic Commerce?',
    answer: 'Logicbroker\'s analytics tools provide insight into agent-driven engagement, conversion, and revenue impact across your digital ecosystem.',
  },
];

const FAQSection = () => {
  const [expanded, setExpanded] = useState<string | false>('faq1'); // First FAQ expanded by default

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const AccordionComponent = (isExpanded) => isExpanded ? FAQAccordion : FAQAccordionCollapsed;

  return (
    <FAQContainer>
      <SectionTitle>
        FAQ
      </SectionTitle>
      <Box>
        {faqs.map((faq) => {
          const StyledAccordion = AccordionComponent(expanded === faq.id);
          return (
            <StyledAccordion
              key={faq.id}
              expanded={expanded === faq.id}
              onChange={handleChange(faq.id)}
              elevation={0}
            >
              <FAQSummary
                expandIcon={<ExpandMore sx={{ color: '#012237' }} />}
              >
                <FAQQuestion>
                  {faq.question}
                </FAQQuestion>
              </FAQSummary>
              <FAQDetails>
                <FAQAnswer>
                  {faq.answer}
                </FAQAnswer>
              </FAQDetails>
            </StyledAccordion>
          );
        })}
      </Box>
    </FAQContainer>
  );
};

export default FAQSection;